// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__mV2U2","col":"styles_col__1zkF4"};